module.exports = __webpack_public_path__ + "img/mizhi-back-cp@2x.a99c5b67.png";